"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
const react_1 = require("@emotion/react");
const fa_1 = require("react-icons/fa");
const CloseButton_1 = __importDefault(require("../elements/CloseButton"));
const styles = (0, react_1.css) `
  overflow: auto;
  width: 400px;

  .inner-container {
    padding: 5px;
    width: 100%;
    height: 180px;
    border: none;
  }

  .main-buttons-container {
    padding: 5px 0;
    border-bottom: 0.55px solid #ebebeb;
    display: flex;
    justify-content: space-between;
  }

  button {
    background-color: transparent;
    border: none;
    padding: 0 5px;
  }

  button:disabled {
    opacity: 0.6;
  }
`;
function CopyClipboardModal({ text, onClose, onCopyClick, }) {
    return ((0, jsx_runtime_1.jsxs)("div", { css: styles, children: [(0, jsx_runtime_1.jsxs)("div", { className: "main-buttons-container handle", children: [(0, jsx_runtime_1.jsx)("button", { type: "button", onClick: () => onCopyClick(text), children: (0, jsx_runtime_1.jsx)(fa_1.FaCopy, {}) }), (0, jsx_runtime_1.jsx)(CloseButton_1.default, { onClick: onClose })] }), (0, jsx_runtime_1.jsx)("div", { className: "inner-container", 
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: { __html: text } })] }));
}
exports.default = CopyClipboardModal;
